import React, { useState, useEffect } from 'react';
import { useTranslations } from '@unisporkal/localization';
import CheckMarkIcon from '../../../../icons/SmallCheckMark.svg?icon';
import styles from './BatchDownloadForm.module.scss';
import useBatchDownload from '../../../../hooks/queries/useBatchDownload';

interface NotZippedDownloaded {
  [assetId: string]: { isClicked: boolean };
}

const DownloadsNotZipped = () => {
  const t = useTranslations();
  const { response } = useBatchDownload();
  const { multiDownloadsNotZipped = [] } = response || {};
  const [notZippedDownloaded, setNotZippedDownloaded] =
    useState<NotZippedDownloaded>({});

  const prepareNotZippedDownloaded = () => {
    if (multiDownloadsNotZipped.length > 0) {
      const newNotZipped: NotZippedDownloaded = {};
      multiDownloadsNotZipped.forEach((item) => {
        if (item && item.assetId) {
          newNotZipped[item.assetId] = { isClicked: false };
        }
      });
      setNotZippedDownloaded(newNotZipped);
    }
  };

  useEffect(() => {
    prepareNotZippedDownloaded();
  }, [multiDownloadsNotZipped]);

  if (multiDownloadsNotZipped.length > 0) {
    return (
      <>
        <p
          className={styles.linkLabel}
          data-testid="not-zipped-downloads"
        >
          {t('batch_download_links_description')}
        </p>
        {multiDownloadsNotZipped
          .map((item) => {
            if (!item || !item.assetId) return null;
            return (
              <div
                className={styles.linkContainer}
                key={item.assetId}
              >
                <a
                  className={styles.link}
                  href={item.url}
                >
                  {item.assetId}
                </a>
                {notZippedDownloaded[item.assetId]?.isClicked && (
                  <div className="">
                    <CheckMarkIcon />
                  </div>
                )}
              </div>
            );
          })
          .filter(Boolean)}
      </>
    );
  }
  return null;
};

export default DownloadsNotZipped;
